import { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'

import Snackbar from 'components/Snackbar'

export const ErrorSeatNotification = ({ onClose }: TSFixMe): TSFixMe => {
  useEffect((): TSFixMe => {
    setTimeout((): TSFixMe => {
      onClose()
    }, 5 * 1000)
  }, [])

  return (
    <Snackbar.Container>
      <Snackbar.Content>
        <FormattedMessage id="seats.error.message" defaultMessage="There was error while selecting your seat." />
      </Snackbar.Content>

      <Snackbar.Action onClick={onClose}>
        <FormattedMessage id="seats.error.action" defaultMessage="Close" />
      </Snackbar.Action>
    </Snackbar.Container>
  )
}
